export enum ConfigTypes {
  GET_COUNTRIES = 'GET_COUNTRIES',
  GET_REGIMENS = 'GET_REGIMENS',
  GET_OCCUPATIONS= 'GET_OCCUPATIONS',
  GET_COMMERCIAL_SECTORS= 'GET_COMMERCIAL_SECTORS',
  GET_MARITAL_STATUS = 'GET_MARITAL_STATUS',
  GET_COMMISSIONS = 'GET_COMMISSIONS',
  LOGOUT = 'LOGOUT'
}
